import React from "react";
import { Col, Row } from "antd";
import MerchantInfo from "../card/merchantInfo";
import MerchantSummary from "../card/merchantSummary";
import MerchantSettings from "../card/merchantSettings";

const MerchantDashboard = () => {
  return (
    <Row gutter={10}>
      <Col md={5}>
        <MerchantInfo />
        <MerchantSettings />
      </Col>
      <Col md={19}>
        <MerchantSummary />
      </Col>
      {/* <Col md={6}>
        <MerchantTickets />
      </Col> */}
    </Row>
  );
};

export default MerchantDashboard;
